import type { RootState } from "src/store";
import { selectCurrentWorkspaceId } from "src/store/app";

import { fetchGroups } from "@dashboard/devices/store";
import { isAnyOf, ListenerMiddlewareInstance, UnsubscribeListener } from "@reduxjs/toolkit";

import { policiesApi } from ".";

const groupsRefreshActions = isAnyOf(
    policiesApi.endpoints.updatePolicy.matchFulfilled,
    policiesApi.endpoints.assignPolicyToGroups.matchFulfilled,
    policiesApi.endpoints.unassignPolicyFromGroups.matchFulfilled,
    policiesApi.endpoints.deletePolicy.matchFulfilled,
);

export const initPoliciesListener = (listenerMiddleware: ListenerMiddlewareInstance): UnsubscribeListener => {
    return listenerMiddleware.startListening({
        matcher: groupsRefreshActions,
        effect: (_action, listenerApi) => {
            const workspaceId = selectCurrentWorkspaceId(listenerApi.getState() as RootState);
            if (!workspaceId) {
                return;
            }

            void listenerApi.dispatch(fetchGroups(workspaceId));
        },
    });
};
